import { render, staticRenderFns } from "./CompletenessIndicator.vue?vue&type=template&id=57807b7c"
import script from "./CompletenessIndicator.vue?vue&type=script&lang=js"
export * from "./CompletenessIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports